export { SourceInfoModule } from './SourceInfoModule';
export { getSourceInfoDisplay, hasSourceInfoData } from './sourceInfoModule.utils';
